/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { CallState, CallStateSelectors, getError } from '@elio/shared/models';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { capitalize } from './string.utils';

export const mergeCallStates = (...callStates: CallState[]): CallState => {
  let resultCallState: CallState = 'INIT';
  for (const currentCallState of callStates) {
    resultCallState = currentCallState;
    if (currentCallState !== 'LOADED') {
      break;
    }
  }
  return resultCallState;
};

export const createCallStateSelector = <FeatureName extends string>(
  name: FeatureName,
  ...state: MemoizedSelector<object, any>[]
): CallStateSelectors<FeatureName> => {
  const getCallState = createSelector(...state, (...states: any[]) =>
    mergeCallStates(...states.map((s) => s.callState))
  );
  const callStateSelectors: CallStateSelectors<FeatureName> = {
    [`get${capitalize(name)}CallState`]: getCallState,
    [`is${capitalize(name)}Loading`]: createSelector(getCallState, (callState: CallState) => callState === 'LOADING'),
    [`is${capitalize(name)}Loaded`]: createSelector(getCallState, (callState: CallState) => callState === 'LOADED'),
    [`get${capitalize(name)}ErrorMessage`]: createSelector(
      getCallState,
      (callState: CallState) => getError(callState)?.messageKey
    ),
  } as unknown as CallStateSelectors<FeatureName>;
  return callStateSelectors;
};
